export const DEFAULT_OPEN_CONTROLS = { tables: ['tables'], active: ['active'], data: ['data'], files: ['files'] };
